module.exports = __webpack_public_path__ + "static/person-a272a29aedcc581f65e6ce9f0ea77b47.png";